import { PDFViewer, StyleSheet } from '@react-pdf/renderer'
import { ReservationDocument } from './Files/ReservationDocument'
import { PDFLoading } from './';
import '../styles/PDF.css'

const mockInfo = {
  name: 'Josue Martinez',
  date: '16-09-2025',
  tour: 'tikal',
  schedule: '4:00-21:00',
  passengers: 2,
  included: [1, 2, 3, 4, 5],
  notIncluded: [1, 2, 3, 4, 5],
};

export const PDFComponent = ({ reservationData = mockInfo, reservationCode }) => {
  const viewerStyle = StyleSheet.create({
    width: '58vw',
    height: '85vh',
    textAlign: 'center',
  });

  if (reservationData === undefined){
    return <PDFLoading />;
  }
  

  return (
    <>
        <div className="pdf-container">
            <div className="pdf-viewer">
                <PDFViewer style={ viewerStyle }>
                    <ReservationDocument reservationData={ reservationData } reservationCode={ reservationCode } />
                </PDFViewer>
            </div>
        </div>
    </>
  )
}
